<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

// Status pill for TourBooking. Kept separate from RentalStatusPill because the
// tour lifecycle (pending/confirmed/completed/cancelled) differs from the
// rental one (pending/active/returned/cancelled). Tones are palette-stable
// semantic tokens, consistent with the calendar color_token convention.
const props = defineProps({
  status: { type: String, required: true },
})
const { t } = useI18n()

const CONFIG = {
  pending:   { tone: 'warn', variant: 'soft',    icon: 'clock' },
  confirmed: { tone: 'ok',   variant: 'soft',    icon: '' },
  completed: { tone: 'muted', variant: 'soft',   icon: 'check' },
  cancelled: { tone: 'muted', variant: 'outline', icon: '', strike: true },
}

const resolved = computed(() => CONFIG[props.status] || { tone: 'muted', variant: 'soft', icon: '' })
</script>

<template>
  <UiStatusPill
    :tone="resolved.tone"
    :variant="resolved.variant"
    :icon="resolved.icon"
    :label="t(`tourBookings.statuses.${status}`, status)"
    :strike="resolved.strike || false"
  />
</template>
